var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1280,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.07,555,1062,249.92a64,64,0,0,0-35-33l-250-96.87a16,16,0,0,0-20.27,8.17L744,155.4c-17.13,36.85-58,60.66-104,60.66s-86.91-23.81-104-60.66l-12.63-27.15a16,16,0,0,0-20.27-8.17L253,217a64,64,0,0,0-35,33L77.93,555a32,32,0,0,0,16.6,42.84l193.74,82V1097a64,64,0,0,0,64,64H927.78a64,64,0,0,0,64-64V679.89l193.74-82A32,32,0,0,0,1202.07,555ZM895.8,1065H384.2V520.07a32,32,0,0,0-32-32h-32a32,32,0,0,0-32,32v55.58l-95.65-40.5L299.75,301.8,473.1,234.64c38.64,48.06,100.12,77.42,166.9,77.42s128.26-29.36,166.9-77.42L980.25,301.8l107.13,233.35-95.65,40.5V520.07a32,32,0,0,0-32-32h-32a32,32,0,0,0-32,32Z",
    style: {
      fill: "#282828"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimImageNormal);
export default __webpack_public_path__ + "static/media/sim_image_normal.efd4069b53d6c228d7a52c778bb95cd7.svg";
export { ForwardRef as ReactComponent };